import * as React from "react"

export function People(props) {
  return (
    <svg
    width={43}
    height={43}
    viewBox="0 0 43 43"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_29_92)" fill="#currentColor">
    <path
          d="M28.875 22c-1.767 0-3.475-.789-4.813-2.22-1.3-1.397-2.094-3.26-2.234-5.243-.15-2.116.496-4.061 1.817-5.48 1.32-1.417 3.167-2.182 5.23-2.182 2.048 0 3.9.779 5.216 2.193 1.33 1.428 1.977 3.37 1.827 5.468-.143 1.986-.936 3.848-2.234 5.243C32.35 21.21 30.643 22 28.874 22zm11.329 15.125H17.547a2.382 2.382 0 01-1.891-.917 2.597 2.597 0 01-.452-2.216c.724-2.906 2.516-5.315 5.184-6.968 2.367-1.466 5.381-2.274 8.487-2.274 3.167 0 6.102.773 8.483 2.239 2.673 1.644 4.469 4.067 5.189 7.008a2.6 2.6 0 01-.457 2.215 2.378 2.378 0 01-1.886.913zM12.633 22.344c-3.024 0-5.683-2.812-5.93-6.268-.122-1.77.43-3.407 1.547-4.608 1.105-1.188 2.664-1.843 4.383-1.843 1.719 0 3.265.658 4.377 1.854 1.125 1.21 1.675 2.843 1.546 4.599-.246 3.455-2.904 6.266-5.923 6.266zm5.642 2.703c-1.511-.74-3.473-1.11-5.641-1.11-2.532 0-4.99.66-6.924 1.859-2.193 1.36-3.667 3.341-4.263 5.733a2.354 2.354 0 00.412 2.007 2.175 2.175 0 001.726.839h9.54a.688.688 0 00.676-.565c.01-.054.021-.108.035-.161.729-2.927 2.436-5.4 4.96-7.204a.687.687 0 00-.055-1.15 6.993 6.993 0 00-.466-.248z"
        fill="#currentColor"
      />
    </g>

  </svg>
   
  );
}

